var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoderatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#4F46E5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 42,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#ffffff"
  }, "C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoderatory);
export default __webpack_public_path__ + "static/media/coderatory.a2e4c8b8e972f2aa4e50ee22be98ed64.svg";
export { ForwardRef as ReactComponent };